import { tv } from 'tailwind-variants';

// prettier-ignore
const styles = tv({
  base: `
    iris:flex
    iris:h-full 
    iris:w-full
    iris:flex-col
    iris:items-start
    iris:justify-start

    iris:rounded-(--comp-size-radius-card)
    iris:border
    iris:p-(--comp-space-padding-card-all) 
  `,
  variants: {
    interactive: {
      true: `
        iris:cursor-pointer 
        iris:outline-none
        iris:focus-visible:ring-2
        iris:focus-visible:ring-offset-2
      `,
      false: ""
    },
    variant: {
      standard: `
        iris:border-(--comp-color-border-card-standard)
        iris:bg-(--comp-color-background-card-standard)
      `,
      subtle: `
        iris:border-(--comp-color-border-card-subtle)
        iris:bg-(--comp-color-background-card-subtle)
      `,
      brand: `
        iris:border-(--comp-color-border-card-brand)
        iris:bg-(--comp-color-background-card-brand)
      `,
      "brand-subtle": `
        iris:border-(--comp-color-border-card-brand-subtle) 
        iris:bg-(--comp-color-background-card-brand-subtle)
      `
    },
    inverse: {
      true: `
        iris:focus-visible:ring-(--sem-color-border-interactive-inverse-selected)
        iris:focus-visible:ring-offset-(--sem-color-background-neutral-inverse-primary)
      `,
      false: `
        iris:focus-visible:ring-(--sem-color-border-interactive-selected)
        iris:focus-visible:ring-offset-(--sem-color-background-neutral-primary)
      `
    }
  },
  compoundVariants: [{
    variant: "standard",
    inverse: true,
    class: `
        iris:border-(--comp-color-border-card-standard-inverse)
        iris:bg-(--comp-color-background-card-standard-inverse)
      `
  }, {
    variant: "subtle",
    inverse: true,
    class: `
        iris:border-(--comp-color-border-card-subtle-inverse) 
        iris:bg-(--comp-color-background-card-subtle-inverse)
      `
  }, {
    variant: "brand",
    inverse: true,
    class: `
        iris:border-(--comp-color-border-card-brand-inverse)
        iris:bg-(--comp-color-background-card-brand-inverse)
      `
  }, {
    variant: "brand-subtle",
    inverse: true,
    class: `
        iris:border-(--comp-color-border-card-brand-subtle-inverse)
        iris:bg-(--comp-color-background-card-brand-subtle-inverse)
      `
  }]
});

export { styles as default };
